import React from "react"
import autobind from "class-autobind"
import { IDateRange, ISuspensePunchData } from "../../models"
import WarningIcon from "material-ui/svg-icons/alert/warning"
import * as timecardHelper from "../../helpers/timecardHelper"
import ToolTip from "react-portal-tooltip"
import { amberA400 } from "material-ui/styles/colors"

interface IProps {
    keyStr: string | number
    dateRange: IDateRange
    suspensePunchData: ISuspensePunchData
    hideToolTip?: boolean
    iconSize?: number
    handleOpenVirtualTimecardPopup?(): void
}
interface IState {
    open: boolean
}

export default class TimecardSuspenseInfoIcon extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    render() {
        const suspenseReasons = timecardHelper.getSuspenseReasonsByDateRange(this.props.dateRange, this.props.suspensePunchData)
        if (suspenseReasons.length === 0)
            return null
        return (
            <div>
                <ToolTip active={this.state.open} position="bottom" arrow="center" parent={`#suspense-${this.props.keyStr}`}>
                    <div style={{ paddingLeft: 15, paddingRight: 15 }}>
                        <ul style={{ paddingInlineStart: 10 }}>
                            {suspenseReasons.map((reason, index) =>
                                <li key={index}>
                                    {reason}
                                </li>
                            )}
                        </ul>
                    </div>
                </ToolTip>
                <div id={`suspense-${this.props.keyStr}`}>
                    <WarningIcon
                        style={{ color: amberA400, width: this.props.iconSize || 20, height: this.props.iconSize || 20 }}
                        onClick={e => {
                            e.stopPropagation()
                            this.props.handleOpenVirtualTimecardPopup &&
                                this.props.handleOpenVirtualTimecardPopup()
                        }}
                        onMouseOver={() => !this.props.hideToolTip && this.setState({ open: true })}
                        onMouseOut={() => !this.props.hideToolTip && this.setState({ open: false })}
                    />
                </div>
            </div>
        )
    }
}

